var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.events,
                  "item-text": "name",
                  "item-value": "id",
                  disabled: _vm.isLoading,
                  label: "Event",
                  outlined: "",
                  dense: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.selectedEvent,
                  callback: function($$v) {
                    _vm.selectedEvent = $$v
                  },
                  expression: "selectedEvent"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "my-3 font-weight-bold text-h6" }, [
        _vm._v("Rumour Documents")
      ]),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c("v-checkbox", {
                staticClass: "mt-1",
                attrs: { label: "Include Unapproved?" },
                model: {
                  value: _vm.includeUnapproved,
                  callback: function($$v) {
                    _vm.includeUnapproved = $$v
                  },
                  expression: "includeUnapproved"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            [
              _c(
                "v-btn",
                {
                  attrs: { disabled: !_vm.selectedEvent || _vm.isLoading },
                  on: { click: _vm.getRumoursDoc }
                },
                [_vm._v("Download Rumours")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }